import type { Decoration } from 'src/services/apollo/generated/graphql'

export function decorationRemarkEditable(decoration: Decoration) {
  return decoration.allowUserEditRemark === true
}
